export const StepIndicator = ({ steps, currentIndex }) => {
  return (
    <ol
      data-testid="step-indicator"
      className="flex flex-wrap items-center gap-x-6 gap-y-2 font-mono text-[10px] uppercase tracking-[0.18em]"
    >
      {steps.map((step, idx) => {
        const isCurrent = idx === currentIndex;
        const isDone = idx < currentIndex;
        return (
          <li
            key={step.id}
            data-testid={`step-indicator-${step.id}`}
            className="flex items-center gap-2"
          >
            <span
              className={`flex h-5 w-5 items-center justify-center border ${
                isCurrent
                  ? "border-foreground bg-foreground text-white"
                  : isDone
                    ? "border-emerald-700 text-emerald-800"
                    : "border-border text-muted-foreground"
              }`}
            >
              {isDone ? "✓" : String(idx + 1).padStart(2, "0")}
            </span>
            <span
              className={
                isCurrent
                  ? "text-foreground"
                  : isDone
                    ? "text-emerald-800"
                    : "text-muted-foreground"
              }
            >
              {step.label}
            </span>
            {idx < steps.length - 1 && (
              <span className="ml-2 hidden h-px w-8 bg-border md:inline-block" />
            )}
          </li>
        );
      })}
    </ol>
  );
};
